import {
    FETCHED_USERS,
    FETCHED_USER_ROLES,
    FETCH_USER,
    FETCHED_USER_SITES,
    FETCHED_USER_LANGUAGES,
    UPDATED_USER_ROLES,
    FETCHED_PERMISSIONS_GROUPED,
    FETCHED_USER_PERMISSIONS
} from './types';

import update from 'immutability-helper';

const INITIAL_STATE = {
    allUsers: [],
    user: {},
    userRoles: [],
    userSites: [],
    userLanguages: [],
    groupedPermissions: [],
    userPermissions: []
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCHED_USERS:

            return update(state, {
                allUsers: {$set: action.payload.data},
            });

        case FETCH_USER:

            return update(state, {
                user: {$set: action.user}
            });

        case FETCHED_USER_ROLES:

            let userRolesIds = [];
            action.roles.forEach((role) => {
                userRolesIds.push({
                    value: role.id,
                    label: role.display_name
                });
            });

            return update(state, {
                userRoles: {$set: userRolesIds},
            });

        case FETCHED_USER_SITES:

            let userSitesIds = [];
            action.userSites.forEach( (site) => {
                userSitesIds.push({
                    value: site.id,
                    label: site.name
                });
            });

            return update(state, {
                userSites: {$set: userSitesIds},
            });

        case FETCHED_USER_LANGUAGES:

            let userLanguagesIds = [];
            action.userLanguages.forEach( (language) => {
                userLanguagesIds.push({
                    value: language.id,
                    label: language.name
                });
            });

            return update(state, {
                userLanguages: {$set: userLanguagesIds},
            });

        case UPDATED_USER_ROLES:

            return update(state, {
                userRoles: {$set: action.data.roles},
                userSites: {$set: action.data.sites},
                userLanguages: {$set: action.data.languages}
            });

        case FETCHED_PERMISSIONS_GROUPED:

            return update(state, {
                groupedPermissions: {$set: action.groupedPermissions}
            });

        case FETCHED_USER_PERMISSIONS:

            let userPermIds = []
            action.userPermissions.map(userPerm => {
                userPermIds.push(userPerm.id);
                return userPermIds;
            })

            return update(state, {
                userPermissions: {$set: userPermIds}
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/users/reducer.js